export const types = {
  'SET_PAGE_NUMBER': 'SET_PAGE_NUMBER',
};
